@if (ad !== null && !ad.reserved) {
  <div class="relative flex flex-col border border-[#E4E4E4] rounded-[6px] h-[355px] overflow-hidden">
    <!-- Bild -->
    <a class="relative flex w-full h-[235px] bg-[#F5F5F5] justify-center items-center overflow-hidden md:cursor-pointer" routerLink="/entry/{{ad.id}}">
      <kaz-blur-image [src]="ad.images.length > 0 ? (ad.images[ad.titleImageIndex] | imageSource) : getDummyPicture(ad)" [placeholder]="ad.images.length === 0"></kaz-blur-image>
    </a>
    <!-- Text & Preis & Ort -->
    <a class="flex flex-col pt-4 px-4 pb-2.5 flex-1 cursor-pointer" routerLink="/entry/{{ad.id}}">
      <span class="text-2xl text-[#161D26] font-bold line-clamp-2 break-words hyphens-auto" lang="de" [title]="ad.title">{{ad.title}}</span>
      <div class="flex items-baseline mt-auto w-full gap-2">
        @if (ad.category.subName !== 'Verschenken' && +ad.price > 0) {
          <span class="text-base text-[#56BA90] font-semibold whitespace-nowrap">€ {{ad.price | currency:'EUR':'':'1.0-0':'de-DE'}} {{ad.priceType === PriceType.VHB ? 'VHB' : '' }}</span>
        }
        <span class="ml-auto text-xs text-[#999999]/70 font-medium truncate" title="{{ad.category.localityName && ad.category.localityName !== '' ? ad.category.localityName : ad.category.subName}}">{{ad.category.localityName && ad.category.localityName !== '' ? ad.category.localityName : ad.category.subName}}</span>
      </div>
    </a>
  </div>
}
